if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // fmnv-adjustment begin: 'Multi-Item Add für Additional Services'
        const fmnvServices = document.querySelector('[data-fmnv-services]');
        const selectedServices = fmnvServices?.querySelectorAll('.fmnv-services__checkbox:checked') || [];
        const isMultiItemAdd = selectedServices.length > 0;

        if (isMultiItemAdd) {
          // Items Array bauen: Hauptprodukt + Services
          const items = [
            {
              id: parseInt(formData.get('id')),
              quantity: parseInt(formData.get('quantity')) || 1
            }
          ];

          selectedServices.forEach(checkbox => {
            items.push({
              id: parseInt(checkbox.dataset.variantId),
              quantity: 1
            });
          });

          // JSON Request statt FormData (ohne Sections, die kommen im zweiten Request)
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({ items });
        } else {
          config.body = formData;
        }
        // fmnv-adjustment end

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // fmnv-adjustment begin: 'Sections nachladen bei Multi-Item Add'
            let cartResponse = response;

            if (isMultiItemAdd && this.cart) {
              // Bei Multi-Item: Sections über Section Rendering API laden
              const sectionIds = this.cart.getSectionsToRender().map(section => section.id);
              const sectionsUrl = `${window.location.pathname}?sections=${sectionIds.join(',')}`;
              const sectionsResponse = await fetch(sectionsUrl);
              const sectionsData = await sectionsResponse.json();

              // Response-Objekt für renderContents aufbauen
              // Verwende den Key des Hauptprodukts (erstes Item)
              cartResponse = {
                key: response.items[0].key,
                sections: sectionsData
              };
            }
            // fmnv-adjustment end

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: cartResponse,
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-quick-view');

            if (quickViewModal) {
              quickViewModal.classList.remove('quick-view-loaded');
              document.body.classList.remove('quickview-open');
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(cartResponse);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(cartResponse);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
